import { render, staticRenderFns } from "./nearAccidentDetailAppr.vue?vue&type=template&id=0fc87600"
import script from "./nearAccidentDetailAppr.vue?vue&type=script&lang=js"
export * from "./nearAccidentDetailAppr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fc87600')) {
      api.createRecord('0fc87600', component.options)
    } else {
      api.reload('0fc87600', component.options)
    }
    module.hot.accept("./nearAccidentDetailAppr.vue?vue&type=template&id=0fc87600", function () {
      api.rerender('0fc87600', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/appr/sop/iim/nearAccidentDetailAppr.vue"
export default component.exports